import type { MediaOrientation } from "@shared/media";
import type { Translate } from "../i18n/translate";

/** The CMS word for an orientation; `ORIENTATION_LABELS` in `@shared/media` is English only. */
export function orientationLabel(
  t: Translate,
  orientation: MediaOrientation
): string {
  switch (orientation) {
    case "landscape":
      return t("common:labels.landscape");
    case "portrait":
      return t("common:labels.portrait");
    default:
      return t("common:labels.fitsBoth");
  }
}
